export default __webpack_public_path__ + "64a2c356a902a305360e39cb84978e5c.png";